import React, { useCallback, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import Path from '@leverege/path';
import { Attributes } from '@leverege/ui-attributes';
import { PortalOverlay } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import MapProvider from "../../dataViewers/map/mapbox/MapProvider.js";
import Utils from "./Utils.js";
import S from './CreateUpdateItem.css';
import { AttributeValueEditorFormFactory } from "../forms/Factory.js";
import LoadingView from "../../views/LoadingView.js";
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.imagine.view.CreateItem');
export default function CreateItem(props) {
  const {
    show,
    onClose,
    relationship,
    delegate,
    initialData = {}
  } = props;
  const {
    blueprint
  } = relationship;
  const isMobile = useMediaQuery({
    query: '(max-width: 430px)'
  });
  let closeLoading;
  const onSuccess = useCallback(res => {
    closeLoading?.();
    onClose?.();
    Utils.handleFormResult(res, {
      delegate,
      blueprint,
      relationship,
      onClose,
      type: 'create'
    });
  }, [blueprint, delegate, relationship, onClose, closeLoading]);
  const onError = useCallback(err => {
    closeLoading?.();
    Utils.handleFormError(err, {
      delegate,
      blueprint,
      relationship,
      onClose,
      type: 'create',
      initialData
    });
  }, [blueprint, delegate, initialData, relationship, onClose, closeLoading]);
  const onOkay = useCallback(() => {
    closeLoading = LoadingView.showDialog(t('loadingDialog', {
      blueprintName: blueprint.name
    }));
  }, []);
  const [target] = useState({
    type: blueprint.type,
    ref: delegate.getInterfaceUrl(),
    data: {
      ...initialData
    }
  });

  // If the object has a geoPosition attribute, populate it by default
  // TODO: Currently, this will not have the submit button show up, even 
  // though there is data. It looks like its there are no changes.
  if (MapProvider.isMapAvailable()) {
    const geoAttr = Attributes.getAttribute('geoPosition', blueprint.type);
    const editable = geoAttr?.blueprint?.editable || geoAttr?.blueprint?.attribute?.source === 'user';
    if (editable && geoAttr?.blueprint?.attribute != null) {
      if (geoAttr.get(initialData) == null) {
        Path.set(geoAttr.blueprint.updatePath, initialData, MapProvider.getCenter());
      }
    }
  }
  const attributes = Utils.getAttributes(blueprint.type, 'create');
  const CreateComponent = AttributeValueEditorFormFactory.create(`${blueprint.type}.create`, {
    target,
    attributes,
    onSuccess,
    onError,
    onOkay,
    onCancel: onClose,
    title: t('title', {
      blueprintName: blueprint.name
    }),
    icon: blueprint.getIcon('createDialogIcon') || blueprint.getIcon('screenIcon'),
    context: {
      clientProps: {
        ...props
      },
      usage: 'form',
      isCreate: true
    }
  });
  return /*#__PURE__*/_jsx(PortalOverlay, {
    position: isMobile ? 'full' : 'center',
    show: show,
    closeOnEscape: false,
    closeOnDocumentClick: false,
    onClose: onClose,
    targetId: "moltenPortalRoot",
    children: /*#__PURE__*/_jsx("div", {
      className: S.container,
      children: CreateComponent
    })
  });
}